import { useNavigate, useParams } from 'react-router-dom';

import { PATH } from 'constants/path';

export const useLibrary = () => {
  const navigationTo = useNavigate();

  const params = useParams();

  const { institutionId } = params;

  const isExcercisesPath = location.pathname.includes(PATH.EXERCISES);

  const isLessonsPath = location.pathname.includes(PATH.LESSONS);

  const isCoursesPath = location.pathname.includes(PATH.COURSES);

  const isFunctionalTestPath = location.pathname.includes(PATH.FUNCTIONAL_TESTS);

  const isAssessmentsPath = location.pathname.includes(PATH.ASSESSMENTS);

  const onClickAddItem = () => {
    switch (true) {
      case isExcercisesPath:
        navigationTo(
          `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.EXERCISES}/${PATH.ADD_EXERCISES}`,
        );
        break;

      case isLessonsPath:
        navigationTo(
          `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.LESSONS}/${PATH.ADD_LESSONS}`,
        );
        break;

      case isCoursesPath:
        navigationTo(
          `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.COURSES}/${PATH.ADD_COURSES}`,
        );
        break;

      case isFunctionalTestPath:
        navigationTo(
          `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.FUNCTIONAL_TESTS}/${PATH.ADD_FUNCTIONAL_TESTS}`,
        );
        break;

      case isAssessmentsPath:
        navigationTo(
          `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.ASSESSMENTS}/${PATH.ADD_ASSESSMENTS}`,
        );
        break;

      default:
        break;
    }
  };

  return { onClickAddItem };
};
